import { CheckboxInput, FormItem } from '@framework/form';
import * as React from 'react';

export interface ILayoutRemoveBorderConfigInputProps {}

export function LayoutRemoveBorderConfigInput(
  props: ILayoutRemoveBorderConfigInputProps,
) {
  return (
    <FormItem
      name="layout.removeBorder"
      label={null}
      layout={{ removeLabelSpace: true }}
    >
      <CheckboxInput name="layout.removeBorder" defaultChecked={false}>
        Rimuovi bordo grafico
      </CheckboxInput>
    </FormItem>
  );
}
